import { useEffect, useState, useRef } from "react";
import styles from "../styles/Slideshow.module.css";

export default function Slideshow({ pages, showDots }) {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);
  const delay = 6000;

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === pages.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index, pages.length]);

  return (
    <div className={styles.slideshow}>
      <div
        className={index === 0 ? styles.slideshowSliderEnd : styles.slideshowSlider}
        style={{position:"relative", transform: `translate3d(${-index * 100}%, 0, 0)` }}
      >
        {pages.map((page, idx) => (
          <div key={idx} className={styles.slide}>
          {page}
          </div>
        ))}
      </div>

      {showDots !== false && <div className={styles.slideshowDots}>
        {pages.map((_, idx) => (
          <div
            key={idx}
            className={`${styles.slideshowDot} ${index === idx ? styles.slideshowDotactive : ""}`}
            onClick={() => {
              setIndex(idx);
            }}
          ></div>
        ))}
      </div>}
    </div>
  );
}
